import { EventBus, EventBusRageTransport } from './common/events';
import { HousesEditorService } from './services/HousesEditorService';
import {
	AccessControlService,
	AccountsService,
	AdminService,
	AdsService,
	BackendService,
	BankService,
	BarberShopService,
	ButtonActionsService,
	CasesService,
	CatchRingService,
	CharacterCreationService,
	CharacterSelectionService,
	ChatService,
	ClothesShopService,
	ClothesTesterService,
	ConfigService,
	ContactsService,
	DailyTasksService,
	DialogueService,
	DonateItemService,
	DonateService,
	DrivingSchoolService,
	EntitySearchService,
	ExchangeService,
	FeedbackService,
	GameConfigService,
	GameFishingService,
	GameService,
	GasStationService,
	GpsService,
	GreenScreenService,
	GuiService,
	HandlingTuningService,
	HousesService,
	HudService,
	IAccessControlService,
	IAccountsService,
	IAdminService,
	IAdsService,
	IBarberShopService,
	IButtonActionsService,
	ICasesService,
	ICatchRingService,
	ICharacterCreationService,
	ICharacterSelectionService,
	IClothesShopService,
	IClothesTesterService,
	IContactsService,
	IDailyTasksService,
	IDialogueService,
	IDonateItemService,
	IDonateService,
	IDrivingSchoolService,
	IExchangeService,
	IFeedbackService,
	IGameFishingService,
	IGpsService,
	IGreenScreenService,
	IHudService,
	IInventoryDonateService,
	IInventoryService,
	IJobElectricianService,
	IJobFarmerService,
	ILootBuyersService,
	IMessagesService,
	IPhoneCallsService,
	IPhoneService,
	IPhotoModeService,
	IProductShopService,
	IPromoService,
	IQuestsService,
	IRadialMenuService,
	IReportService,
	IRestrictionsService,
	IRockPaperScissorsService,
	IRuncodeService,
	ISoundsService,
	ISpawnSelectService,
	IStatsService,
	ITabletService,
	ITattooShopService,
	ITechTuningService,
	ITuningTesterService,
	IVehicleMarketService,
	IVehiclePaintShopService,
	IVehiclePassportService,
	IVehicleRegistrationService,
	IVehicleServiceStationService,
	IVehicleTuningShopService,
	IWeatherService,
	IBetaRewardsService,
	InputService,
	InventoryDonateService,
	InventoryService,
	JobElectricianService,
	JobFarmerService,
	JobTasksService,
	JobsService,
	LicensesService,
	LootBuyersService,
	MessagesService,
	ModalService,
	NotificationsService,
	PhoneCallsService,
	PhoneService,
	PhotoModeService,
	PlayerService,
	ProductShopService,
	PromoService,
	QuestsService,
	RadialMenuService,
	ReportService,
	RestrictionsService,
	RockPaperScissorsService,
	RpcService,
	RuncodeService,
	SoundsService,
	SpawnSelectService,
	StatsService,
	TabletService,
	TattooShopService,
	TechTuningService,
	TuningTesterService,
	VarsService,
	VehicleMarketService,
	VehicleNumberPlateService,
	VehiclePaintShopService,
	VehiclePassportService,
	VehicleRegistrationService,
	VehicleService,
	VehicleServiceStationService,
	VehicleShopService,
	VehicleTuningShopService,
	WeatherService,
	BetaRewardsService,
} from './services';
import {
	CharacterSkillsService,
	ICharacterSkillsService,
} from './services/CharacterSkills';
import {
	HelpModalService,
	IHelpModalService,
} from './services/HelpModalService';
import { IRageClient } from './types';
import { setupRageConsoleHooks } from './utils';

export class RageClient implements IRageClient {
	public readonly gui: GuiService;
	// public readonly auth: AuthService;
	public readonly game: GameService;
	public readonly notifications: NotificationsService;
	public readonly player: PlayerService;
	public readonly accounts: IAccountsService;
	public readonly vehicleShop: VehicleShopService;
	public readonly config: ConfigService;
	public readonly gameConfig: GameConfigService;
	public readonly vehicles: VehicleService;
	public readonly bank: BankService;
	public readonly gasStation: GasStationService;
	public readonly chat: ChatService;
	public readonly input: InputService;
	public readonly search: EntitySearchService;
	public readonly jobs: JobsService;
	public readonly backend: BackendService;
	public readonly vehicleNumberPlates: VehicleNumberPlateService;
	public readonly handlingTuning: HandlingTuningService;
	public readonly licenses: LicensesService;
	public readonly houses: HousesService;
	public readonly modal: ModalService;
	public readonly drivingSchool: IDrivingSchoolService;
	public readonly photoMode: IPhotoModeService;
	public readonly exchange: IExchangeService;
	public readonly clothesShop: IClothesShopService;
	public readonly cases: ICasesService;
	public readonly dailyTasks: IDailyTasksService;
	public readonly vehiclePaintShop: IVehiclePaintShopService;
	public readonly vehicleTuningShop: IVehicleTuningShopService;
	public readonly characterCreation: ICharacterCreationService;

	// @TODO
	// public readonly characterEditor: ICharacterEditorService;
	public readonly radialMenu: IRadialMenuService;
	public readonly dialogues: IDialogueService;
	public readonly vehiclePassport: IVehiclePassportService;
	public readonly greenScreen: IGreenScreenService;
	public readonly promo: IPromoService;
	public readonly donateItem: IDonateItemService;
	public readonly quests: IQuestsService;
	public readonly restrictions: IRestrictionsService;
	public readonly buttonActions: IButtonActionsService;
	public readonly clothesTester: IClothesTesterService;
	public readonly housesEditor: HousesEditorService;
	public readonly vehicleRegistration: IVehicleRegistrationService;
	public readonly vehicleMarket: IVehicleMarketService;
	public readonly gameFishing: IGameFishingService;
	public readonly jobFarmer: IJobFarmerService;
	public readonly jobElectrician: IJobElectricianService;
	public readonly tablet: ITabletService;
	public readonly tuningTester: ITuningTesterService;
	public readonly vehicleServiceStation: IVehicleServiceStationService;
	public readonly inventory: IInventoryService;
	public readonly characterSelection: ICharacterSelectionService;
	public readonly accessControl: IAccessControlService;
	public readonly admin: IAdminService;
	public readonly tattooShop: ITattooShopService;
	public readonly reports: IReportService;
	public readonly messages: IMessagesService;
	public readonly contacts: IContactsService;
	public readonly ads: IAdsService;
	public readonly phone: IPhoneService;
	public readonly phoneCalls: IPhoneCallsService;
	public readonly gps: IGpsService;
	public readonly stats: IStatsService;
	public readonly techTuning: ITechTuningService;
	public readonly barberShop: IBarberShopService;
	public readonly productShop: IProductShopService;
	public readonly lootBuyers: ILootBuyersService;
	public readonly skills: ICharacterSkillsService;
	public readonly helpModal: IHelpModalService;
	public readonly catchRing: ICatchRingService;
	public readonly rockPaperScissors: IRockPaperScissorsService;
	public readonly runcode: IRuncodeService;
	public readonly weather: IWeatherService;
	public readonly betaRewards: IBetaRewardsService;
	public readonly hud: IHudService;
	public readonly donate: IDonateService;
	public readonly inventoryDonate: IInventoryDonateService;
	public readonly spawnSelect: ISpawnSelectService;
	public readonly feedback: IFeedbackService;
	public readonly sounds: ISoundsService;

	constructor() {
		setupRageConsoleHooks();

		console.log('[RageClient] Initializing');

		EventBus.setTransport(new EventBusRageTransport());

		const rpc = new RpcService();
		const vars = new VarsService(rpc);
		const config = new ConfigService();

		this.backend = new BackendService(rpc);
		this.gameConfig = new GameConfigService(rpc, this.backend);

		this.gui = new GuiService(rpc);
		this.game = new GameService(vars, rpc);
		this.notifications = new NotificationsService(rpc, this.backend);
		this.modal = new ModalService(this.backend, this.notifications, this.gui);
		this.vehicles = new VehicleService(
			rpc,
			vars,
			this.gameConfig,
			this.backend,
		);
		this.player = new PlayerService(
			vars,
			this.backend,
			this.modal,
			this.notifications,
			this.gameConfig,
			this.vehicles,
		);
		this.accounts = new AccountsService(rpc, this.backend);
		this.vehicleShop = new VehicleShopService(
			rpc,
			this.player,
			this.backend,
			this.notifications,
			this.gameConfig,
			vars,
		);
		this.config = config;
		this.bank = new BankService(
			this.backend,
			this.gameConfig,
			this.notifications,
			rpc,
			this.player,
		);
		this.gasStation = new GasStationService(rpc, this.vehicles);
		this.chat = new ChatService(rpc, this.gui, vars);
		this.input = new InputService(rpc);
		this.sounds = new SoundsService(rpc, vars);
		this.search = new EntitySearchService(this.backend, rpc);
		this.vehicleNumberPlates = new VehicleNumberPlateService(
			this.backend,
			this.vehicles,
			rpc,
			this.notifications,
			this.gameConfig,
			vars,
		);
		this.handlingTuning = new HandlingTuningService(
			rpc,
			this.backend,
			this.vehicles,
			this.player,
			this.gameConfig,
			vars,
		);
		this.licenses = new LicensesService(this.backend, this.gameConfig);
		this.houses = new HousesService(
			this.backend,
			this.player,
			this.gameConfig,
			rpc,
			this.notifications,
			this.modal,
		);
		this.drivingSchool = new DrivingSchoolService(
			rpc,
			this.gameConfig,
			this.licenses,
		);
		this.photoMode = new PhotoModeService(rpc);
		this.exchange = new ExchangeService(
			this.backend,
			this.player,
			this.notifications,
			rpc,
			this.gameConfig,
		);
		this.clothesShop = new ClothesShopService(
			rpc,
			this.backend,
			this.gameConfig,
			this.player,
			vars,
		);
		this.cases = new CasesService(
			this.backend,
			this.gameConfig,
			this.notifications,
			this.vehicles,
		);
		this.dailyTasks = new DailyTasksService(
			this.backend,
			this.notifications,
			this.gameConfig,
		);
		this.vehiclePaintShop = new VehiclePaintShopService(
			rpc,
			this.gameConfig,
			this.backend,
			this.vehicles,
		);
		this.vehicleTuningShop = new VehicleTuningShopService(
			this.backend,
			this.gameConfig,
			this.vehicles,
			rpc,
			vars,
		);
		this.characterCreation = new CharacterCreationService(rpc, this.gameConfig);
		// @TODO
		// this.characterEditor = new CharacterEditorService(
		// 	rpc,
		// 	this.gameConfig,
		// 	this.backend,
		// );
		this.radialMenu = new RadialMenuService(vars, rpc);
		this.dialogues = new DialogueService(
			this.gameConfig,
			this.backend,
			rpc,
			vars,
			this.notifications,
		);
		this.vehiclePassport = new VehiclePassportService(
			this.gameConfig,
			vars,
			this.backend,
			rpc,
		);
		this.greenScreen = new GreenScreenService(rpc, this.gameConfig);
		this.promo = new PromoService(
			this.backend,
			rpc,
			this.player,
			this.notifications,
		);
		this.donateItem = new DonateItemService(rpc);
		this.quests = new QuestsService(vars, this.backend);
		this.restrictions = new RestrictionsService(vars);
		this.buttonActions = new ButtonActionsService(rpc);
		this.clothesTester = new ClothesTesterService(rpc, vars);
		this.housesEditor = new HousesEditorService(rpc, vars);
		this.vehicleRegistration = new VehicleRegistrationService(
			this.backend,
			rpc,
			this.gameConfig,
		);
		this.vehicleMarket = new VehicleMarketService(
			rpc,
			vars,
			this.gameConfig,
			this.backend,
			this.player,
		);
		this.jobFarmer = new JobFarmerService(rpc, this.gameConfig);
		this.jobElectrician = new JobElectricianService(rpc, this.gameConfig);
		this.tablet = new TabletService(rpc);
		this.tuningTester = new TuningTesterService(
			rpc,
			vars,
			this.input,
			this.gameConfig,
			this.vehicles,
		);
		this.vehicleServiceStation = new VehicleServiceStationService(
			rpc,
			vars,
			this.backend,
			this.vehicles,
			this.gameConfig,
		);
		this.inventory = new InventoryService(
			this.player,
			this.backend,
			vars,
			this.gameConfig,
			rpc,
			this.notifications,
		);
		this.gameFishing = new GameFishingService(
			this.gameConfig,
			rpc,
			vars,
			this.backend,
			this.inventory,
		);
		this.characterSelection = new CharacterSelectionService(
			vars,
			rpc,
			this.gameConfig,
		);
		this.accessControl = new AccessControlService(vars, this.gameConfig);
		this.admin = new AdminService(this.backend, rpc, vars);
		this.tattooShop = new TattooShopService(this.backend, this.gameConfig, rpc);
		this.ads = new AdsService(
			this.gameConfig,
			this.backend,
			this.notifications,
			this.player,
		);
		this.contacts = new ContactsService(this.backend);
		this.reports = new ReportService(
			this.backend,
			rpc,
			this.player,
			this.notifications,
		);
		this.phone = new PhoneService(rpc, vars, this.backend);
		this.messages = new MessagesService(rpc);
		this.phoneCalls = new PhoneCallsService(rpc, this.backend);
		this.gps = new GpsService(rpc, vars);
		this.stats = new StatsService(rpc, this.backend);
		this.techTuning = new TechTuningService(
			this.backend,
			this.gameConfig,
			rpc,
			this.vehicles,
		);
		this.barberShop = new BarberShopService(this.backend, this.gameConfig, rpc);
		this.productShop = new ProductShopService(
			this.gameConfig,
			rpc,
			this.backend,
			vars,
		);
		this.lootBuyers = new LootBuyersService(
			rpc,
			this.backend,
			vars,
			this.gameConfig,
			this.player,
		);
		this.skills = new CharacterSkillsService(this.gameConfig, this.backend);
		this.helpModal = new HelpModalService(vars, this.gameConfig);
		this.catchRing = new CatchRingService(rpc, vars);
		this.rockPaperScissors = new RockPaperScissorsService(rpc, vars);

		const dailyTasks = new DailyTasksService(
			this.backend,
			this.notifications,
			this.gameConfig,
		);

		this.dailyTasks = dailyTasks;
		this.hud = new HudService(vars, dailyTasks);

		const jobTasks = new JobTasksService(
			this.backend,
			this.gameConfig,
			this.notifications,
			vars,
		);
		this.jobs = new JobsService(rpc, vars, this.gameConfig, jobTasks);

		this.weather = new WeatherService(vars);
		this.betaRewards = new BetaRewardsService(
			this.gameConfig,
			rpc,
			this.backend,
		);
		this.hud = new HudService(vars, dailyTasks);
		this.donate = new DonateService(vars, this.backend, this.gameConfig);
		this.inventoryDonate = new InventoryDonateService(
			this.backend,
			this.cases,
			this.gameConfig,
		);
		this.spawnSelect = new SpawnSelectService(vars, rpc);
		this.feedback = new FeedbackService(this.backend, rpc, this.notifications);
		this.runcode = new RuncodeService(rpc);
	}
}
